import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-632b32c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { style: {"width":"100%"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加质保")
const _hoisted_4 = ["title"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_7 = {
  class: "flexCenter",
  style: {"width":"90%"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_9 = ["href"]

import { ref,reactive,computed,nextTick,onMounted } from 'vue';
    import { 
		apiName
	} from '@/api/api';
    import {
        requestZcglAdd,
        requestZcglDetails,
		requestAllUser
    } from '@/api/zcApi.js';
    import {
        requestGetAllConfig,
        requestConfigXh
    } from '@/api/configApi.js';
    import { ElMessage } from 'element-plus';
    
export default /*#__PURE__*/_defineComponent({
  name: 'AddZc',
  props: {
        id:{
            type:Number,
            default:0
        },
		userList:{
			type:Object,
			default:()=> {}
		}
    },
  emits: ['searchList','addshow'],
  setup(__props, { emit }) {

const props = __props

    
    
    const wjfileList = ref<any[]>([])
    const api = reactive(apiName)
    const form = ref({
        name:'',
        status:'1',
        bh:'',
        lx:'',
        xlh:'',
        jdpp:'',
        jdxh:'',
        gys:'',
        gmrq:'',
        sybm:'',
        wbzq:'',
        bfzq:'',
        fj:'',
		createuserid:''
    })
    const zqList = ref<any[]>([])
    const openUrl = ref<string>('')
    const dkRef = ref()
    const gysList = ref<any[]>([])
    const bmList = ref<any[]>([])
    const zclxList = ref<any[]>([])
    const pid0 = ref<any[]>([])
    const pid0List = ref<any[]>([])
	const jy = ref(false)
    onMounted(()=>{
		if(props.userList.rolelist!="管理员"){
			jy.value = true
		}
        if(props.id != 0){
            requestZcglDetails({
                id:props.id
            }).then((res:any)=>{
                if(res.status === 1){
                    form.value = res.datalist[0]
                    //附件
                    wjfileList.value = []
                    if(form.value.fj!= ''){
                        form.value.fj.split(',').forEach((val:any)=>{
                            wjfileList.value.push({url:val})
                        })
                    }
                    jdChange(form.value.jdpp,1);
                    zqList.value = res.datalist2
                }
            })
        }
        getGys();
        getBm();//使用部门
        getZclx();
        getJdpp();
    })
    const delZq = (i:number) => {
        zqList.value.splice(i,1)
    }
    const addZq = () => {
        zqList.value.push({name:'',wbnum:'1',wbzq:'年',bfnum:'1',bfzq:'年'})
    }
    // const jdChange1 = (val:string) => {
    //     requestConfigXh({
    //         type:"设备品牌列表",
    //         pid:val
    //     }).then((res:any)=>{
    //         if(res.status === 1){
    //             pid0List.value = res.datalist
    //         }
    //     })
    // }
    const jdChange = (val:string,index:number) => {
        if(!index){
            form.value.jdxh = ""
        }
        if(val==''){
            return
        }
        requestConfigXh({
            type:"设备产品",
            pid:val
        }).then((res:any)=>{
            if(res.status === 1){
                pid0List.value = res.datalist
            }
        })
    }
    const getJdpp = () => {
        requestGetAllConfig({
            type:"设备品牌列表"
        }).then((res:any)=>{
            if(res.status === 1){
                pid0.value = res.datalist
            }
        })
    }
    const getZclx = () => {
        requestGetAllConfig({
            type:"资产类型"
        }).then((res:any)=>{
            if(res.status === 1){
                zclxList.value = res.datalist
            }
        })
    }
    const getBm = () => {
        // requestGetAllConfig({
        //     type:"资产使用部门"
        // }).then((res:any)=>{
        //     if(res.status === 1){
        //         bmList.value = res.datalist
        //     }
        // })
		requestAllUser().then((res:any)=>{
			if(res.status === 1){
				bmList.value = res.datalist
			}
		})
    }
    const getGys = () => {
        requestGetAllConfig({
            type:"供应商管理"
        }).then((res:any)=>{
            if(res.status === 1){
                gysList.value = res.datalist
            }
        })
    }
    // 打开文件
    const open = (item:any) =>{
        openUrl.value = item.url?item.url:item.response.data[0].url
        nextTick(()=>{
            dkRef.value.click();
        })
    }
    // 删除文件
    const del = (index:number) => {
        wjfileList.value.splice(index,1)
    }
    const submit = () => {
        let wjArr:any[] = []
        if(wjfileList.value.length>0){
            wjfileList.value.forEach((val:any)=>{
                if(val.response){
                    wjArr.push(val.response.data[0].url)
                }else{
                    wjArr.push(val.url)
                }
            })
        }
        form.value.fj = wjArr.join(',')
        requestZcglAdd({
            id:props.id,
            name:form.value.name,
            status:form.value.status,
            bh:form.value.bh,
            lx:form.value.lx,
            xlh:form.value.xlh,
            jdpp:form.value.jdpp,
            jdxh:form.value.jdxh,
            gys:form.value.gys,
            gmrq:form.value.gmrq,
            sybm:form.value.sybm,
            fj:form.value.fj,
			createuserid:form.value.createuserid,
            zb:JSON.stringify(zqList.value)
        }).then((res:any)=>{
            if(res.status === 1){
			    ElMessage({
			        message: "提交成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
                    emit('searchList');
                    emit('addshow');
				},500)
			}else{
                ElMessage.error(res.msg);
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FolderAdd = _resolveComponent("FolderAdd")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_FolderOpened = _resolveComponent("FolderOpened")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      "label-width": "100px",
      class: "flexWrap"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "资产类型",
          style: {"width":"45%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              disabled: jy.value,
              modelValue: form.value.lx,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.lx) = $event)),
              placeholder: "请选择",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zclxList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.value,
                    value: item.value,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "资产名称",
          style: {"width":"45%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: jy.value,
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.name) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "品牌",
          style: {"width":"45%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              disabled: jy.value,
              filterable: "",
              onChange: jdChange,
              modelValue: form.value.jdpp,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.jdpp) = $event)),
              placeholder: "请选择",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pid0.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.value,
                    value: item.id,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "型号",
          style: {"width":"45%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              disabled: jy.value,
              filterable: "",
              modelValue: form.value.jdxh,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.jdxh) = $event)),
              placeholder: "请选择",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pid0List.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.value,
                    value: item.id,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "资产状态",
          style: {"width":"45%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              disabled: jy.value,
              modelValue: form.value.status,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.status) = $event)),
              placeholder: "请选择",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "使用中",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "损坏维修",
                  value: "2"
                }),
                _createVNode(_component_el_option, {
                  label: "正在闲置",
                  value: "3"
                }),
                _createVNode(_component_el_option, {
                  label: "已报废",
                  value: "4"
                })
              ]),
              _: 1
            }, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "资产编号",
          style: {"width":"45%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.value.bh,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.bh) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "序列号",
          style: {"width":"45%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: jy.value,
              modelValue: form.value.xlh,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.xlh) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "供应商",
          style: {"width":"45%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              disabled: jy.value,
              filterable: "",
              modelValue: form.value.gys,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.gys) = $event)),
              placeholder: "请选择",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gysList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.value,
                    value: item.id,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "服务开始时间",
          style: {"width":"45%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              disabled: jy.value,
              style: {"width":"100%"},
              modelValue: form.value.gmrq,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.gmrq) = $event)),
              type: "date",
              placeholder: "服务开始时间",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "对应单位",
          style: {"width":"45%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              disabled: jy.value,
              filterable: "",
              modelValue: form.value.createuserid,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.createuserid) = $event)),
              placeholder: "请选择",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bmList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.id,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zqList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flexAlign",
            key: index,
            style: {"width":"95%"}
          }, [
            _createVNode(_component_el_form_item, {
              label: `名称${index+1}`,
              style: {"width":"30%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  disabled: jy.value,
                  modelValue: item.name,
                  "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                  style: {}
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["label"]),
            _createVNode(_component_el_form_item, {
              label: "维保周期",
              style: {"width":"33%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_el_input, {
                    disabled: jy.value,
                    modelValue: item.wbnum,
                    "onUpdate:modelValue": ($event: any) => ((item.wbnum) = $event),
                    type: "number",
                    style: {"width":"60px","margin-right":"5px"}
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_el_select, {
                    disabled: jy.value,
                    modelValue: item.wbzq,
                    "onUpdate:modelValue": ($event: any) => ((item.wbzq) = $event),
                    placeholder: "",
                    style: {"width":"60px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "年",
                        value: "年"
                      }),
                      _createVNode(_component_el_option, {
                        label: "月",
                        value: "月"
                      })
                    ]),
                    _: 2
                  }, 1032, ["disabled", "modelValue", "onUpdate:modelValue"])
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, {
              label: "报废周期",
              style: {"width":"33%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_input, {
                    disabled: jy.value,
                    modelValue: item.bfnum,
                    "onUpdate:modelValue": ($event: any) => ((item.bfnum) = $event),
                    type: "number",
                    style: {"width":"60px","margin-right":"5px"}
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_el_select, {
                    disabled: jy.value,
                    modelValue: item.bfzq,
                    "onUpdate:modelValue": ($event: any) => ((item.bfzq) = $event),
                    placeholder: "",
                    style: {"width":"60px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "年",
                        value: "年"
                      }),
                      _createVNode(_component_el_option, {
                        label: "月",
                        value: "月"
                      })
                    ]),
                    _: 2
                  }, 1032, ["disabled", "modelValue", "onUpdate:modelValue"])
                ])
              ]),
              _: 2
            }, 1024),
            (!jy.value)
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  onClick: ($event: any) => (delZq(index)),
                  style: {"color":"red","font-size":"20px","margin-bottom":"15px","cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CircleCloseFilled)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (!jy.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (addZq())),
              type: "primary",
              size: "small",
              style: {"margin":"0 0 15px 100px"}
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "上传附件",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            (!jy.value)
              ? (_openBlock(), _createBlock(_component_el_upload, {
                  key: 0,
                  "file-list": wjfileList.value,
                  "onUpdate:file-list": _cache[11] || (_cache[11] = ($event: any) => ((wjfileList).value = $event)),
                  action: `${api}/frame/uploadfile1`,
                  "show-file-list": false,
                  accept: ".jpg,.jpeg,.png,.pdf,.doc,.docx"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, {
                      class: "addfj",
                      size: 28,
                      color: "#909399"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FolderAdd)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "action"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wjfileList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "morefj1",
                key: index
              }, [
                _createElementVNode("a", {
                  href: "javascript:;",
                  title: item.name,
                  class: "morefj",
                  style: {"position":"relative"}
                }, [
                  _createVNode(_component_el_icon, {
                    size: 28,
                    color: "#409eff",
                    onClick: ($event: any) => (open(item))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FolderOpened)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (!jy.value)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:;",
                        title: "删除",
                        onClick: ($event: any) => (del(index))
                      }, [
                        _createVNode(_component_el_icon, {
                          size: 20,
                          color: "red",
                          style: {"position":"absolute","top":"0px","right":"0px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CircleCloseFilled)
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_4)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      (!jy.value)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _cache[12] || (_cache[12] = ($event: any) => (submit())),
            type: "primary",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("a", {
      href: `${api}${openUrl.value}`,
      target: "_blank",
      ref_key: "dkRef",
      ref: dkRef
    }, null, 8, _hoisted_9)
  ], 64))
}
}

})